import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import SummaryApi from "../common";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

 const submit = async () => {
    if (!email) {
      toast.error("Please enter email");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        SummaryApi.forgotPassword.url,
        { email }
      );

      toast.success("If email exists, reset link has been sent");

    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to send reset link"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-sm mx-auto">
      <h2 className="text-xl font-bold">Forgot Password</h2>

      <input
        className="border p-2 w-full mt-3"
        placeholder="Enter your email"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />

      <button
        className="bg-[#5a3620] text-white px-4 py-2 mt-3 w-full disabled:opacity-60"
        onClick={submit}
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Reset Link"}      
      </button>
    </div>
  );
}
